import { render, staticRenderFns } from "./BillARChange.vue?vue&type=template&id=2b59b479"
import script from "./BillARChange.vue?vue&type=script&lang=js"
export * from "./BillARChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports